import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { imgUrl, formatPrice } from "../lib/api";
import { useLanguage } from "../context/LanguageContext";
import { useCart } from "../context/CartContext";
import { catLabel, productName } from "../lib/i18n";

export const ProductCard = ({ product, index = 0 }) => {
  const { lang, t } = useLanguage();
  const { addItem } = useCart();
  const navigate = useNavigate();
  const soldOut = (product.stock ?? 0) <= 0;

  const onAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (soldOut) return;
    addItem(product, 1);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: (index % 3) * 0.08 }}
      className="group relative flex flex-col gap-5 cursor-pointer"
      data-testid={`product-card-${product.id}`}
      onClick={() => navigate(`/product/${product.id}`)}
    >
      <div className="aspect-[4/5] overflow-hidden bg-brand-bg2 relative">
        <img
          src={imgUrl(product.images && product.images[0])}
          alt={productName(product, lang)}
          loading="lazy"
          className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105"
          onError={(e) => { e.target.src = imgUrl(null); }}
        />
        {soldOut && (
          <span className="absolute top-4 left-4 bg-brand-ink/90 text-white text-[10px] tracking-[0.15em] uppercase px-3 py-1">
            {t("out_of_stock")}
          </span>
        )}
        <button
          data-testid={`add-to-cart-${product.id}`}
          onClick={onAdd}
          disabled={soldOut}
          className="absolute bottom-0 left-0 w-full translate-y-full group-hover:translate-y-0 transition-transform duration-300 bg-brand-ink/90 backdrop-blur-md text-white text-center py-4 text-xs tracking-[0.15em] uppercase disabled:opacity-50"
        >
          {soldOut ? t("out_of_stock") : t("add_to_cart")}
        </button>
      </div>

      <div className="flex justify-between items-start px-1">
        <div>
          <p className="overline mb-1">{catLabel(product.category, lang)}</p>
          <Link
            to={`/product/${product.id}`}
            onClick={(e) => e.stopPropagation()}
            className="font-serif text-xl text-brand-ink leading-tight hover:text-brand-sub transition-colors"
          >
            {productName(product, lang)}
          </Link>
        </div>
        <p className="font-sans text-sm tracking-wider text-brand-sub whitespace-nowrap pt-1">
          {formatPrice(product.price)}
        </p>
      </div>
    </motion.div>
  );
};
